
    import './styles.scoped.css';
    export default {
  "column-layout": "awsui_column-layout_vj6p7_1five_189",
  "grid": "awsui_grid_vj6p7_1five_221",
  "grid-no-gutters": "awsui_grid-no-gutters_vj6p7_1five_227",
  "grid-variant-text-grid": "awsui_grid-variant-text-grid_vj6p7_1five_231",
  "grid-breakpoint-default": "awsui_grid-breakpoint-default_vj6p7_1five_239",
  "grid-columns-1": "awsui_grid-columns-1_vj6p7_1five_242",
  "grid-breakpoint-xxs": "awsui_grid-breakpoint-xxs_vj6p7_1five_242",
  "grid-breakpoint-xs": "awsui_grid-breakpoint-xs_vj6p7_1five_245",
  "grid-columns-2": "awsui_grid-columns-2_vj6p7_1five_248",
  "grid-columns-3": "awsui_grid-columns-3_vj6p7_1five_254",
  "grid-columns-4": "awsui_grid-columns-4_vj6p7_1five_260",
  "grid-vertical-borders": "awsui_grid-vertical-borders_vj6p7_1five_276",
  "grid-horizontal-borders": "awsui_grid-horizontal-borders_vj6p7_1five_309",
  "root": "awsui_root_vj6p7_1five_359",
  "tile-container": "awsui_tile-container_vj6p7_1five_394",
  "refresh": "awsui_refresh_vj6p7_1five_419",
  "selected": "awsui_selected_vj6p7_1five_423",
  "disabled": "awsui_disabled_vj6p7_1five_423",
  "readonly": "awsui_readonly_vj6p7_1five_423",
  "has-metadata": "awsui_has-metadata_vj6p7_1five_426",
  "columns": "awsui_columns_vj6p7_1five_448",
  "column-1": "awsui_column-1_vj6p7_1five_455",
  "breakpoint-xs": "awsui_breakpoint-xs_vj6p7_1five_462",
  "breakpoint-xxs": "awsui_breakpoint-xxs_vj6p7_1five_466",
  "column-2": "awsui_column-2_vj6p7_1five_470",
  "column-3": "awsui_column-3_vj6p7_1five_485",
  "column-4": "awsui_column-4_vj6p7_1five_500",
  "control": "awsui_control_vj6p7_1five_516",
  "no-image": "awsui_no-image_vj6p7_1five_520",
  "image": "awsui_image_vj6p7_1five_524"
};
  